import { render, staticRenderFns } from "./custom-radio.vue?vue&type=template&id=72150da5&"
import script from "./custom-radio.vue?vue&type=script&lang=js&"
export * from "./custom-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports